import { ReplayRecordingType } from './ReplayRecordingType'
import { Visibility } from './Visibility'

export class Room {
    roomMetadataId!: string
    tagName?: string
    notificationIconUrl?: string
    libraryCardUrl?: string
    libraryHeroUrl?: string
    mapPath!: string
    contentMetadataId!: string
    isVisibleInMenu?: boolean
    roomName!: string
    companyId!: string
    description?: string
    replayRecordingType?: ReplayRecordingType
    maxVisibility?: Visibility
    isSinglePlayer?: boolean;
    isHub?: boolean;
    isAugmentedRealityCompatible?: boolean;
    isCreatableByExternalUsers?: boolean;
    allowUserFiles?: boolean;
    allowSinglePlayer?: boolean;
    maxUsers?: number;
}